export enum UserLoginStatus {
    pendingInvitation = "pendingInvitation",
    pendingRegistration = "pendingRegistration",
    active = "active",
}
